import SimpleRenderer from '@arcgis/core/renderers/SimpleRenderer';
import { TwcProduct } from '../../../../twc-products';

export const VOLCANIC_POINTS_PRODUCT_DATA: TwcProduct = {
  id: 'volcanic-points',
  defaultProductId: '6015',
  productName: 'Weather-Volcanic-Points',
  label: 'Volcanic Points',
  weatherType: 'Volcanic_points',
  description: 'TWC product (vector) - Volcanic Points',
  series: 'Observation',
  timeSlicePeriodInMinutes: 5,
  lodMax: 0,
  protocol: 'VectorTile',
  forecastTimeSlicePeriod: 0,
  flightLevelProductIds: {},
  zOrder: 90,
  layerSpecs: {
    geoJSON: {
      geometryType: 'point',
      declutter: true,
      renderer: new SimpleRenderer({
        symbol: {
          type: 'picture-marker',
          url: 'assets/weather/volcano.png',
          width: '30px',
          height: '30px'
        } as any
      })
    }
  }
};
